// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"c21951fe","458":"fcb22890","631":"67c7188a","774":"91f02fa3","787":"224c714b","820":"0c1e3d74","851":"7750c63d","858":"d70e3f8b"}[chunkId] + ".chunk.js";
};